import { palette } from './palette';
import background from 'assets/images/faq-banner-large.png';
import savingsBackground from 'assets/images/savings-summary-banner.webp';
import findProviderBackground from 'assets/images/find-provider-banner.webp';
import faqImage from 'assets/images/faq-img.png';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '50vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.isabella-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.header,

      '& .hero-background': {
        objectFit: 'cover',
        height: '600px',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
      },
      '& .section-header': {
        '@media screen and (min-width: 768px)': {
          marginTop: '60px',
        },
      },
      '& .section-header__title': {
        lineHeight: 0,
      },
      '& .home-hero-title': {
        fontSize: '46px',
        color: palette.text.primary,
        maxWidth: '540px',
      },
      '@media screen and (max-width: 768px)': {
        '& .home-hero-title': {
          fontSize: '28px',
          color: palette.text.primary,
        },
      },
      '& .section-header__subtitle-wrapper': {
        margin: '12px 0px',
      },
      '& .home-hero-subtitle': {
        fontSize: '18px',
        maxWidth: 550,
      },
      '& .header': {
        fontWeight: 'bold',
        paddingBottom: '10px',
        lineHeight: 1.5,
      },
      '& .sub-header': {
        fontWeight: 500,
        fontSize: '38px',
        lineHeight: 1,
        '@media screen and (max-width: 768px)': {
          fontSize: '28px',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '& .image': {
          borderRadius: 32,
        },

        '& .definition-service-tile': {
          fontWeight: 500,
          padding: '0px 14px',
        },

        '& .definition-service-description ': {
          fontSize: 17,
          paddingBottom: 40,
          maxWidth: 390,
          margin: '0 auto',
        },

        '& .section-header': {
          paddingBottom: '70px',
        },

        '@media(max-width: 900px)': {
          '& .section-header': {
            paddingBottom: '20px',
          },
        },
      },
    },

    /* Static hero styles */
    '& .hero-static-title': {
      fontWeight: '500',
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.background.main,
      },
      '& .section-header__title': {
        fontWeight: '600 !important',
      },
      '@media screen and (max-width: 768px)': {
        '& .summary-text': {
          fontSize: '16px',
        },
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            background: palette.text.highlight,
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            fontSize: '48px',
            color: palette.primary.main,
            fontWeight: 'bold',
          },
          '& .customUpfrontWrapper': {
            textAlign: 'left',
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 600,
            },
          },
          '& .MuiButton-outlined': {
            border: `1px solid ${palette.primary.main}`,
          },
          '& .planCardHeaderContainer': {
            marginBottom: '0px !important',
          },
        },
        '& .select-plan-button': {
          '&:hover': {
            background: `${palette.primary.main} !important`,
          },
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 550,
      },
      '& .step-counter': {
        backgroundColor: palette.secondary.light,
        color: palette.text.primary,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400,
        color: palette.text.primary,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-header': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        background: palette.background.footer,
      },
      '& .faq-contact-section': {
        padding: '0 !important',
      },
      '& .view-more-button': {
        border: `1px solid ${palette.primary.main}`,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .checkout-hero-section':
      {
        background: palette.background.header,
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.footer,
      },
      '& .hero-static-subtitle': {
        color: palette.text.primary,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.secondary,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .section-header__title': {
          fontWeight: '600 !important',
        },
        '& .testimonial-message': {
          fontSize: '18px',
          fontWeight: '400 !important',
          color: palette.text.primary,
        },
        '& .testimonial-name': {
          display: 'flex',
          justifyContent: 'center',
          color: palette.text.primary,
          fontWeight: '400 !important',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.text.primary,
        },
        '& .react-multi-carousel-dot--active button': {
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          background: `${palette.text.primary} !important`,
        },
        '& .react-multi-carousel-dot button': {
          width: '10px',
          height: '10px',
          borderRadius: '60%',
          background: palette.text.highlight,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100,
          },
          '& .custom-avatar': {
            display: 'none',
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${faqImage})`,
      backgroundPosition: 'right',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedSecondary': {
        background: palette.text.highlight,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },
    '@media(min-width: 1700px)': {
      '& .faq-hero-section': {
        backgroundImage: `url(${faqImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '366px',
      },
    },

    /*faq mobile hero banner img */
    '@media(max-width: 400px)': {
      '& .faq-hero-section': {
        backgroundPosition: 'left',
      },
      '& .find-provider-section, .plan-selection-section, .checkout-hero-section, .savings-hero-section':
        {
          backgroundPosition: 'left! important',
          height: 'unset!important',
        },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: 'rgba(71, 86, 112, 0.8)',
      },
      '& .faq-link': {
        fontWeight: 'normal',
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-subtitle': {
          color: palette.text.primary,
        },
        '& .provider-contact-details': {
          color: palette.text.primary,
        },
        '& .provider-contact-link': {
          color: palette.text.primary,
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.text.primary,
        },
      },
    },

    /* Find Provider Section */
    '& .find-provider-section, .plan-selection-section, .checkout-hero-section':
      {
        backgroundImage: `url(${findProviderBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        height: '380px',

        '& .hero-header-title, .hero-header-subtitle': {
          margin: '0',
          textAlign: 'left',
        },
        '& .hero-header-subtitle': {
          color: palette.text.primary,
        },
        '& .header-container': {
          justifyContent: 'left',
          margin: '0',
        },
        '& .section': {
          marginLeft: 64,
        },
        '@media(max-width: 900px)': {
          '& .section': {
            marginLeft: 0,
          },
        },
      },

    /* Savings Summary */
    '& .savings-hero-section': {
      backgroundImage: `url(${savingsBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'right',
      backgroundRepeat: 'no-repeat',
      height: '380px',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: palette.text.primary,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.footer,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
    '& .customLogout': {
      border: `1px solid ${palette.text.primary}`,
    },
  },
};
